import React, { useState, useEffect } from 'react';
import { getApiClient } from '../../api/apiClient';
import InvoiceStatistics from './InvoiceStatistics';
import IncomingInvoicesList from './IncomingInvoicesList';

const IncomingInvoices = ({ onPreviewInvoice, formatCurrency, formatDate }) => {
  const [incomingInvoices, setIncomingInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchIncomingInvoices();
  }, []);

  const fetchIncomingInvoices = async () => {
    try {
      setLoading(true);
      const client = getApiClient();
      
      // First, check for new invoices from ANAF - must succeed before proceeding
      const anafResponse = await client.get('/admin/getAnaf');
      
      // Only proceed if ANAF check was successful (HTTP 200)
      if (anafResponse.status === 200) {
        console.log('Successfully checked for new invoices from ANAF');
        
        // Then fetch all received invoices
        const response = await client.get('/admin/received');
        console.log('Fetched received invoices:', response.data);
        const transformedInvoices = response.data.map(invoice => ({
          ...invoice,
          type: 'incoming',
          status: invoice.status || 'RECEIVED',
          clientName: invoice.sellerName,
          createdAt: invoice.invoiceDate
        }));

        setIncomingInvoices(transformedInvoices);
      } else {
        console.warn('ANAF check did not return HTTP 200, skipping received invoices fetch');
        setIncomingInvoices([]);
      }
    } catch (error) {
      console.error('Error in fetchIncomingInvoices:', error);
      setIncomingInvoices([]);
    } finally {
      setLoading(false);
    }
  };

  const refreshInvoices = () => {
    fetchIncomingInvoices();
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-500 border-t-transparent"></div>
      </div>
    );
  }

  return (
    <>
      <InvoiceStatistics invoices={incomingInvoices} formatCurrency={formatCurrency} />
      <IncomingInvoicesList 
        invoices={incomingInvoices}
        formatCurrency={formatCurrency}
        formatDate={formatDate}
        onGenerateInvoice={() => {}} // Will be handled by parent
        onPreviewInvoice={onPreviewInvoice}
        onRefresh={refreshInvoices}
      />
    </>
  );
};

export default IncomingInvoices;
